import useGlobal from "../../store";
import {useMutation, useQuery} from "@apollo/react-hooks";
import {VISIT_SCHEDULING, VISIT_SCHEDULING_BASE_MODELS} from "./gql/Queries";
import {CREATE_VISIT_SCHEDULING, UPDATE_VISIT_SCHEDULING} from "./gql/Mutation";
import history from "../../utils/history";
import {CircularProgress} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import CreateUpdateVisitSchedulingForm from "../../forms/visitScheduling/CreateUpdateVisitSchedulingForm";
import React from "react";
import {useTranslation} from "react-i18next";

const VisitSchedulingEdit = (props) => {
  const { t } = useTranslation(["visitScheduling", "common"])
  const { visitScheduling } = props.location.state;
  const [session, globalActions] = useGlobal(
    (state) => state.session,
    (actions) => actions
  );

  const {
    data: visitSchedulingData,
    loading: loadingVisitScheduling,
    error: errorVisitScheduling
  } = useQuery(VISIT_SCHEDULING, {
    variables: {
      where: {
        _id: visitScheduling._id
      }
    },
    fetchPolicy: "network-only"
  });

  const {
    data: baseModels,
    loading: loadingBaseModels,
    error: errorBaseModels,
  } = useQuery(VISIT_SCHEDULING_BASE_MODELS, {
    variables: {
      app: session.user ? session.appRef._id : ""
    },
    fetchPolicy: "nework-only"
  });

  const [updateVisitScheduling] = useMutation(UPDATE_VISIT_SCHEDULING, {
    onCompleted: (mutationData) => {
      console.log("mutationData", mutationData);
      history.push("/visitScheduling")
    }
  });
  if (loadingBaseModels || loadingVisitScheduling) {
    return (
      <div style={style.progressCnt}>
        <CircularProgress style={style.progress} />
      </div>
    );
  } else {
    if(errorBaseModels || errorVisitScheduling) {
      return (
        <div>
          <Alert variant="outlined" severity="error">
            {t('common:common.error.title')}
          </Alert>
        </div>
      );
    }
    const {
      userMobiles,
      visits,
      segments,
    } = baseModels;
    return (<CreateUpdateVisitSchedulingForm
      initialValues={visitSchedulingData.visitScheduling}
      app={session.user ? session.appRef._id : ""}
      userMobiles={userMobiles}
      visits={visits}
      segments={segments}
      submitSuccess={(values) => {
        console.log("submitSuccess");
        console.log(values);
        updateVisitScheduling({
          variables: {
            where: {
              _id: visitScheduling._id
            },
            data: {
              app: session.user ? session.appRef._id : "",
              ...values
            }
          }
        });
      }}
    />);
  }
};

const style = {
  progress: {
    margin: "16px",
  },
  progressCnt: {
    width: "100px !important",
    marginLeft: "50%",
    marginRight: "50%",
  },
};
export default VisitSchedulingEdit;
